export default {
      id: "lely-bg-arrow-usage",
      viewBox: "0 0 320 568",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#lely-bg-arrow",
      toString: function () {
        return this.url;
      }
    }